import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

export const fetchTemplates = createAsyncThunk('templates/fetch', async () => {
  const response = await api.get('/templates');
  return response.data;
});

export const createTemplate = createAsyncThunk('templates/create', async (data) => {
  const response = await api.post('/templates', data);
  return response.data;
});

export const updateTemplate = createAsyncThunk('templates/update', async ({ id, data }) => {
  const response = await api.put(`/templates/${id}`, data);
  return response.data;
});

export const deleteTemplate = createAsyncThunk('templates/delete', async ({ id, force = false }, { rejectWithValue }) => {
  try {
    const url = force ? `/templates/${id}?force=true` : `/templates/${id}`;
    await api.delete(url);
    return id;
  } catch (error) {
    // Pass through the error response data
    return rejectWithValue(error.response?.data || { message: error.message });
  }
});

const templateSlice = createSlice({
  name: 'templates',
  initialState: {
    items: [],
    loading: false,
    error: null
  },
  reducers: {
    clearTemplates: (state) => {
      state.items = [];
      state.loading = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTemplates.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTemplates.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
        state.error = null;
      })
      .addCase(fetchTemplates.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Don't clear items on error, keep existing data
      })
      .addCase(createTemplate.fulfilled, (state, action) => {
        state.items.unshift(action.payload);
      })
      .addCase(updateTemplate.fulfilled, (state, action) => {
        const index = state.items.findIndex(t => t.id === action.payload.id);
        if (index !== -1) {
          state.items[index] = action.payload;
        }
      })
      .addCase(deleteTemplate.fulfilled, (state, action) => {
        state.items = state.items.filter(t => t.id !== action.payload);
      })
      .addCase(deleteTemplate.rejected, (state, action) => {
        state.error = action.payload?.message || 'Failed to delete template';
      });
  }
});

export const { clearTemplates } = templateSlice.actions;
export default templateSlice.reducer;
